import type { DeliveryVo, ReceivePayment } from "@zhihaoscm/entity";
import { PC_RECEIVE_STATE, RECEIVE_PAYMENT_TYPE } from "@zhihaoscm/meta";
import { formatCurrency, TABLE_COLUMN_WIDTH } from "@zhihaoscm/utils";
import dayjs from "dayjs";
import { Table, type TableColumnProps } from "zhihao-ui-react";

const money = (value?: number) => formatCurrency(value);

/** 逐项迁移自旧 delivery/components/payHistory.vue。 */
export function DeliveryPayHistory({ data }: { data: DeliveryVo }) {
    const payments = data.receivePayments ?? [];
    const paid = payments.filter(item => [PC_RECEIVE_STATE.PAID.code, PC_RECEIVE_STATE.OFFLINE_PAID.code].includes(item.state)).reduce((sum, item) => sum + Number(item.amount ?? 0), 0);
    const unpaid = Number(data.delivery.settlementUnitAmount ?? 0) - paid;
    const columns: TableColumnProps<ReceivePayment>[] = [
        { label: "付款编号", prop: "id", width: TABLE_COLUMN_WIDTH.WORD9 },
        { label: "费用类型", prop: "paymentType", width: TABLE_COLUMN_WIDTH.WORD6, enum: RECEIVE_PAYMENT_TYPE.options },
        { label: "费用说明", prop: "remark", width: TABLE_COLUMN_WIDTH.WORD10 },
        { label: "支付金额(元)", prop: "amount", width: TABLE_COLUMN_WIDTH.WORD8, formatter: row => money(row.amount) },
        { label: "支付时间", prop: "payTime", width: TABLE_COLUMN_WIDTH.SHORT_DATE_TIME, formatter: row => row.payTime ? dayjs(row.payTime).format("YYYY-MM-DD HH:mm") : "--" },
        {
            label: "确认支付凭证时间",
            prop: "confirmOperateInfo",
            width: TABLE_COLUMN_WIDTH.SHORT_DATE_TIME,
            formatter: row => {
                if (row.state !== PC_RECEIVE_STATE.OFFLINE_PAID.code || !row.confirmOperateInfo?.length) return "--";
                const latest = row.confirmOperateInfo.reduce((result, item) => dayjs(item.confirmTime).isAfter(dayjs(result.confirmTime)) ? item : result);
                return latest.confirmTime ? dayjs(latest.confirmTime).format("YYYY-MM-DD HH:mm") : "--";
            }
        },
        { label: "支付状态", prop: "state", width: TABLE_COLUMN_WIDTH.WORD5, enum: PC_RECEIVE_STATE.options }
    ];
    return (
        <section className="section-card delivery-detail-section" id="delivery-payment">
            <div className="delivery-section-title-row">
                <h2 className="section-title">付款记录</h2>
                <div><span>已支付金额</span><strong>{money(paid)}元</strong><span>未支付金额</span><strong>{money(unpaid)}元</strong></div>
            </div>
            <Table columns={columns} data={payments} pagination={false} rowKey="id" />
        </section>
    );
}
